import { Components } from '@mui/material/styles';
import { Theme } from '@mui/material';
import { getTypography } from '@/src/materialui/typography/typography.theme';

// Toolbar Header in mobile dialogs
export const flowDatePickerToolbar: Components<Theme>['MuiDatePickerToolbar'] = {
  styleOverrides: {
    root: ({ theme }) => ({
      borderBottom: `1px solid ${theme.palette.surface.secondary}`,
      // buttons wrapping text
      '& .MuiButtonBase-root': {
        borderRadius: '4px',
      },
      // top text, e.g. 'Select date'
      '& .MuiTypography-overline': {
        [theme.breakpoints.up('xs')]: {
          ...getTypography('disclaimer1', theme.direction === 'rtl', 'large'),
          fontWeight: '300',
          color: theme.palette.onSurface.os500,
        },
      },
      // wrapper
      '& .MuiPickersToolbar-content': {
        alignItems: 'flex-end',
        // dates itself
        '& .MuiTypography-root': {
          [theme.breakpoints.up('xs')]: {
            ...getTypography('h2', theme.direction === 'rtl', 'large'),
            fontWeight: '300',
            color: theme.palette.text.primary,
          },
        },
        '& .MuiTypography-subtitle1': {
          [theme.breakpoints.up('xs')]: {
            ...getTypography('h4', theme.direction === 'rtl', 'large'),
            fontWeight: '300',
          },
        },
      },
    }),
  },
};
